// extracted by mini-css-extract-plugin
export default {"IconButton_0":"SubmitButton-module__IconButton_0__LCM4Q5L"};